import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

const StyledWordmark = styled.img`
    width: 120px;
    height: 40px;
`;

export function Wordmark() {
    const { locale } = useIntl();
    const languageCode = locale.split('-')[0];

    return (
        <StyledWordmark
            alt={__('99designs by Vista')}
            src={`https://assets.99static.com/logos/${languageCode}/wordmark_grey.svg`}
        />
    );
}
